import { useState, useEffect } from 'react';
import OrdersList from './OrdersList';
import OrderForm from './OrderForm';
import AdminPanel from './AdminPanel';
import { getOrders } from '../services/api';
import './Dashboard.css';

function Dashboard({ user, onLogout }) {
  const [view, setView] = useState(user.role === 'admin' ? 'admin' : user.role === 'vendeur' ? 'new-order' : 'orders');
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    const ordersResult = await getOrders();

    if (ordersResult.success) {
      setOrders(ordersResult.orders);
    }
    setLoading(false);
  };

  const handleOrderCreated = () => {
    loadData();
    setView('orders');
  };

  const handleOrderUpdated = () => {
    loadData();
  };

  const handleOrderDeleted = () => {
    loadData();
  };

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <div className="header-left">
          <img
            src="https://static.wixstatic.com/media/4a94e6_36d4e5d5d2ff410ebbab6f1a947fac88~mv2_d_1772_1772_s_2.png"
            alt="Ateliers du Château"
            className="logo"
          />
          <h1>Ateliers du Château</h1>
          <div className="user-info">
            <span className={`role-badge ${user.role}`}>
              {user.name}
            </span>
          </div>
        </div>
        <button onClick={onLogout} className="logout-button">
          Déconnexion
        </button>
      </header>

      <nav className="dashboard-nav">
        {user.role === 'admin' && (
          <button
            className={`nav-button ${view === 'admin' ? 'active' : ''}`}
            onClick={() => setView('admin')}
          >
            Administration
          </button>
        )}
        {user.role === 'vendeur' && (
          <button
            className={`nav-button ${view === 'new-order' ? 'active' : ''}`}
            onClick={() => setView('new-order')}
          >
            Nouvelle commande
          </button>
        )}
        {user.role !== 'admin' && (
          <button
            className={`nav-button ${view === 'orders' ? 'active' : ''}`}
            onClick={() => setView('orders')}
          >
            Commandes
          </button>
        )}
      </nav>

      <main className="dashboard-content">
        {loading ? (
          <div className="loading">
            <div className="spinner"></div>
            <p>Chargement...</p>
          </div>
        ) : (
          <>
            {view === 'admin' && user.role === 'admin' && (
              <AdminPanel />
            )}
            {view === 'orders' && user.role !== 'admin' && (
              <OrdersList
                orders={orders}
                user={user}
                onOrderUpdated={handleOrderUpdated}
                onOrderDeleted={handleOrderDeleted}
              />
            )}
            {view === 'new-order' && user.role === 'vendeur' && (
              <OrderForm onOrderCreated={handleOrderCreated} />
            )}
          </>
        )}
      </main>
    </div>
  );
}

export default Dashboard;
